/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldseatsplaceholder3Inputs */

const en_ticketsfieldseatsplaceholder3 = /** @type {(inputs: Ticketsfieldseatsplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No limit`)
};

const de_ticketsfieldseatsplaceholder3 = /** @type {(inputs: Ticketsfieldseatsplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Grenze`)
};

/**
* | output |
* | --- |
* | "No limit" |
*
* @param {Ticketsfieldseatsplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldseatsplaceholder3 = /** @type {((inputs?: Ticketsfieldseatsplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldseatsplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldseatsplaceholder3(inputs)
	return de_ticketsfieldseatsplaceholder3(inputs)
});
export { ticketsfieldseatsplaceholder3 as "ticketsFieldSeatsPlaceholder" }